import React, { Component } from "react";
import i18n from "../../i18n";
import { Toast } from "@react/react-spectrum/Toast";
import moment from "moment";
import "moment/min/locales";

class FlexiblePromoBanner extends Component {
  render() {
    moment.locale(this.props.locale);
    this.props.bannerDetails.fpConessionLocalisedDate = moment(this.props.bannerDetails.conessionDate).format("LL");
    this.props.bannerDetails.fpPromoEndLocalisedDate = moment(this.props.bannerDetails.promoEndDate).format("LL");
    this.props.bannerDetails.fpDueNextDateLocalisedDate = this.props.bannerDetails.dueNextDate ? moment(this.props.bannerDetails.dueNextDate).format("LL") : '';
    this.props.bannerDetails.fpDueLaterDateLocalisedDate = this.props.bannerDetails.dueLaterDate ? moment(this.props.bannerDetails.dueLaterDate).format("LL") : '';
    return (
      <Toast className="fpbanner">
        {this.props.bannerDetails.useCase1 === true &&
          i18n.t(this.props.workFlowId + ".approvalHeaderInfo.FpBannerMessageCase1", this.props.bannerDetails)}
        {this.props.bannerDetails.useCase2 === true &&
          i18n.t(this.props.workFlowId + ".approvalHeaderInfo.FpBannerMessageCase2", this.props.bannerDetails)}
        {this.props.bannerDetails.useCase3 === true &&
          i18n.t(this.props.workFlowId + ".approvalHeaderInfo.FpBannerMessageCase3", this.props.bannerDetails)}
      </Toast>
    );
  }
}

export default FlexiblePromoBanner;
